import * as React from 'react';
import { t } from '../helper/locale';
import * as iconSmileyFace from '../assets/images/icon-smiley-face.svg';

export const HelpTip: React.FunctionComponent<{
  url: string;
}> = ({ url }) => (
  <div className="HelpTip">
    <img className="HelpTip__icon" src={iconSmileyFace} alt="smiling emoji" />

    <p className="HelpTip__text">
      {t('We’re here to help.')}{' '}
      <a className="HelpTip__link" href={url} target="_blank" rel="noreferrer">
        {t('See how to install {{shortName}}.', {
          shortName: t('Qustodio'),
        })}
      </a>
    </p>
  </div>
);
